import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Address\UpdateAddressController::__invoke
* @see app/Http/Controllers/Address/UpdateAddressController.php
* @route '/api/address/{address}'
*/
const UpdateAddressController = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAddressController.url(args, options),
    method: 'put',
})

UpdateAddressController.definition = {
    methods: ["put"],
    url: '/api/address/{address}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Address\UpdateAddressController::__invoke
* @see app/Http/Controllers/Address/UpdateAddressController.php
* @route '/api/address/{address}'
*/
UpdateAddressController.url = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { address: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { address: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            address: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        address: typeof args.address === 'object'
        ? args.address.id
        : args.address,
    }

    return UpdateAddressController.definition.url
            .replace('{address}', parsedArgs.address.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\UpdateAddressController::__invoke
* @see app/Http/Controllers/Address/UpdateAddressController.php
* @route '/api/address/{address}'
*/
UpdateAddressController.put = (args: { address: string | number | { id: string | number } } | [address: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAddressController.url(args, options),
    method: 'put',
})

export default UpdateAddressController